import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import {NgbTabsetConfig} from '@ng-bootstrap/ng-bootstrap';
import { MenuService } from 'src/app/services/panels/menu.service';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs';
import { Menu } from 'src/app/interfaces/menus.interface';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection, DocumentChangeAction } from '@angular/fire/firestore';
import { SingleMenu } from 'src/app/interfaces/singlemenu.interface';
import { ReviewService } from 'src/app/services/review.service';
import { Menureview } from 'src/app/interfaces/menureview';
import { NgForm } from '@angular/forms';
import { AngularFireStorage } from '@angular/fire/storage';
import { Router } from '@angular/router';
import { AdminAccessService } from 'src/app/services/admin-access.service';
import { Access } from 'src/app/interfaces/access';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-add-menu',
  templateUrl: './add-menu.component.html',
  styleUrls: ['./add-menu.component.scss'],
  providers: [NgbTabsetConfig] // add NgbTabsetConfig to the component providers

})
export class AddMenuComponent implements OnInit,OnDestroy {

  menuObservable:Subscription;

  menu: Menu[] = []

  linkRef: AngularFirestoreCollection<any>;

  link: Observable< DocumentChangeAction<unknown> []>

  singlemenu: SingleMenu[] = []

  singlemenuObservable:Subscription;

  reviewsObservable:Subscription;

  reviews: Menureview[] = []

  access: Access[] =[]


  constructor(config: NgbTabsetConfig,
              private GetMenus:MenuService,
              private fs: AngularFirestore,
              private storage: AngularFireStorage,
              private getaccess:AdminAccessService,
              private router:Router,
              private auth:AuthService)
    {
        // customize default values of tabsets used by this component tree
        config.justify = 'center';
        config.type = 'pills';
    }

  ngOnInit(): void {
    this.menuObservable = this.GetMenus.getMenus().subscribe(data => { 
      this.menu = data.map(element => {
        return {
          id:element.payload.doc.id,
          ...element.payload.doc.data() as {},
        }
      })
   })

   this.reviewsObservable = this.getaccess.getAccess().subscribe(data=> {
    this.access = data.map(element => {
      return {
        id:element.payload.doc.id,
        ...element.payload.doc.data() as {},
      }
    })
  })
  }

  pX:boolean=true
  
  sub(id) {
    
    this.pX = false
    
    this.linkRef = this.fs.collection('menus').doc(id).collection('singlemenu', ref => ref.orderBy('title_ar','desc'))
  
    this.link = this.linkRef.snapshotChanges();

    this.singlemenuObservable = this.link.subscribe(data => {
      this.singlemenu = data.map(element => {
        return {
          id:element.payload.doc.id,
          ...element.payload.doc.data() as {},
        }
      })
    })
  }
  viewReviews(id1,id2) {   
    this.linkRef = this.fs.collection(`menus/${id1}/singlemenu/${id2}/reviews`)
  
    this.link = this.linkRef.snapshotChanges();

    this.reviewsObservable = this.link.subscribe(data => {
      this.reviews = data.map(element => {
        return {
          id:element.payload.doc.id,
          ...element.payload.doc.data() as {},
        }
      })
      console.log(data)
    })
  }
  ngOnDestroy() {
    this.menuObservable.unsubscribe();
    this.reviewsObservable.unsubscribe();
    // this.singlemenuObservable.unsubscribe();
  }

  loading:boolean=false

  done:boolean=false

  addlistS:boolean = true

  addList(f1:NgForm) {
    this.loading = true
    this.addlistS = false
    let title = (<Menu>f1.value).title,
        title_ar = (<Menu>f1.value).title_ar;

    this.GetMenus.addListToMenus(title,title_ar)
    .then(()=> {
      this.loading = false
      this.done = true
      setTimeout(() => {
        this.done = false
        this.addlistS = true
      }, 6000);
    })    
  }

  @ViewChild('photoUrl') itemImage:ElementRef;

  addItemToMenuS:boolean = true

  addItemToMenu(f2:NgForm,id:string){

    this.loading = true
    this.addItemToMenuS = false
    let title = (<SingleMenu>f2.value).title,
        title_ar = (<SingleMenu>f2.value).title_ar,
        description = (<SingleMenu>f2.value).description,
        description_ar = (<SingleMenu>f2.value).description_ar,
        price = (<SingleMenu>f2.value).price,
        photoUrl = (<HTMLInputElement>this.itemImage.nativeElement).files[0];

        this.GetMenus.addItemtoMenu(id,title,title_ar,description,description_ar,price,photoUrl)
        .then(()=>{
          this.loading = false
          this.done = true
          setTimeout(() => {
            this.done = false
            this.addItemToMenuS = true
          }, 6000);
        })
  }
  @ViewChild('gPhoto') gPhoto:ElementRef

  submit:boolean = true

  sizeAlert:boolean = false

  photosLength: number = 0

  lengthAlert:boolean = false

  getPhotosLength(id1,id2){
   
    this.linkRef = this.fs.collection(`menus/${id1}/singlemenu/${id2}/photos`)
  
   
    this.link = this.linkRef.valueChanges();

   
    this.link.subscribe(data=> { 
   
      console.log("ITEM SUB PHOTOS =", data.length)
   
      this.photosLength = data.length 
   
    })
  
  }
  
  addPhotos(id1, id2) {

    this.submit = false

    this.loading = true

    this.sizeAlert = false

          let gPhoto =   (<HTMLInputElement>this.gPhoto.nativeElement).files;
          
          for (let i = 0; i < gPhoto.length; i++) {
              
            if(gPhoto.length > 3) {                  
                this.sizeAlert = true
                this.loading = false
                this.submit = true
                return false
            }
             else if(this.photosLength >= 3) {
                         
               this.lengthAlert = true
               this.loading = false
               this.submit = false
               setTimeout(() => {
                this.lengthAlert = false
                this.submit = true  
               }, 4000);  
               return false
             }
            else {
                   this.GetMenus.addPhotos(id1,id2,gPhoto[i]).then(()=>{
                   this.loading = false
                   this.done = true
                   setTimeout(() => {
                     this.done = false
                     this.submit = true
                   }, 6000);
                 })
                 .catch(error => console.log(error))
            }
          }     
          
  }

  
  editListS:boolean = false

  onFocus_editListS() {
    this.editListS = true
  }

  editList(id:string,title:string,title_ar:string) {
    this.loading = true
    this.editListS = false
    this.fs.collection('menus').doc(`${id}`).update({
      title,
      title_ar
    })
    .then(()=> {
      this.loading = false
      this.done = true
      setTimeout(() => {
        this.done = false
        this.editListS = true
      }, 6000);
    })
  }

  deleteListS:boolean = false

  deleteList(id) {
    this.fs.doc(`menus/${id}`).delete()
    .then(()=> {
      this.deleteListS = true
    })
  }

    editItemS:boolean = false

    onFocus_editItemS() {
      this.editItemS = true
    }

    editItem(id:string,id2:string,title:string,title_ar:string,description:string,description_ar:string,price:number) {
      this.editItemS = false
      this.loading = true
      this.fs.doc(`menus/${id}/singlemenu/${id2}`).update({
          title,
          title_ar,
          description,
          description_ar,        
          price,
        })
        .then(()=>{
          this.loading = false
          this.done = true
          setTimeout(() => {
            this.done = false
            this.editItemS = true
          }, 6000);
        })
    }

    // @ViewChild('updatephotoUrl') updatedItemImage:ElementRef;

    // photoChanged:boolean = false

    // photoChangedS:boolean = false

    // changePhotoLoading:boolean = false

    // onFocus_photoChanged() {
    //   this.photoChangedS = true
    // }

    // updatePhoto(id1:string,id2:string){
    //   this.changePhotoLoading = true
    //   this.photoChangedS = false  
    //   let photoUrl = (<HTMLInputElement>this.updatedItemImage.nativeElement).files[0],
    //     ref = this.storage.ref('singlemenu/' + photoUrl.name);
    //     ref.put(photoUrl).then( ()=> {
    //       ref.getDownloadURL().subscribe(photoUrl => {
    //         this.fs.doc(`menus/${id1}/singlemenu/${id2}`).update({
    //           photoUrl
    //         })
    //       })
    //     })
    //     .then(()=>{
    //       this.changePhotoLoading = false
    //       this.photoChanged = true
    //       setTimeout(() => {
    //         this.photoChanged = false
    //       }, 6000);
    //     })
    // }

    deleteItem(id:string,id2:string) {
      this.fs.doc(`menus/${id}/singlemenu/${id2}`).delete()
      .then(()=> {
        console.log('deleted item')
      })
    }

    deleteItemReviewS:boolean = false

    deleteItemReview(id1:string,id2:string,id3:string) {
      this.fs.doc(`menus/${id1}/singlemenu/${id2}/reviews/${id3}`).delete()
      .then(()=> {
        console.log('deleted review')
      })
    }

    deleteAccess(){
      // this.fs.doc(`admins/${id}`).delete()
      this.auth.logout().then(()=>{
        this.router.navigate(['/controls-panel-login'])
      })
    }
}
